const products = [
  {
    id: 1,
    name: 'Cafe Americano',
    price: 5.00,
    image: 'american-coffe.jpg'
  },
  {
    id: 2,
    name: 'Cafe con Leche',
    price: 7.00,
    image: 'coffe-milk.jpg'
  },
  {
    id: 3,
    name: 'Sandwich',
    price: 7.00,
    image: 'sandwich.jpg'
  },
  {
    id: 4,
    name: 'Jugo',
    price: 10.00,
    image: 'orange-juice.jpg'
  }
]

export { products }
